const sk = {
  common: {
    loading: "Načítava sa...",
    dismiss: "Zavrieť",
    status: "Stav",
    providers: {
      google: "Gmail",
      microsoft: "Outlook",
    },
    languages: {
      en: "Angličtina",
      sk: "Slovenčina",
    },
  },
  auth: {
    login: {
      title: "Vitajte späť",
      subtitle: "Prihláste sa a spravujte svoje predplatné",
      submit: "Prihlásiť sa",
      submitting: "Prihlasovanie...",
      noAccount: "Nemáte účet?",
      success: "Prihlásenie bolo úspešné!",
      failed: "Prihlásenie zlyhalo",
    },
    signup: {
      title: "Vytvoriť účet",
      subtitle: "Začnite sledovať svoje predplatné ešte dnes",
      submit: "Vytvoriť účet",
      submitting: "Vytvára sa účet...",
      hasAccount: "Už máte účet?",
      passwordMismatch: "Heslá sa nezhodujú",
      success: "Účet bol úspešne vytvorený!",
      failed: "Registrácia zlyhala",
    },
    fields: {
      email: "E-mail",
      password: "Heslo",
      confirmPassword: "Potvrdiť heslo",
      signUp: "Registrovať sa",
      signIn: "Prihlásiť sa",
    },
  },
  navigation: {
    overview: "Prehľad",
    settings: "Nastavenia",
    emailImports: "Import e-mailov",
    notifications: "Upozornenia",
    signOut: "Odhlásiť sa",
    loggedOut: "Odhlásenie bolo úspešné",
    toggleTheme: "Prepnúť tému",
    openNavigation: "Otvoriť navigáciu",
    closeNavigation: "Zavrieť navigáciu",
    closeOverlay: "Zavrieť prekrytie navigácie",
  },
  dashboard: {
    overviewEyebrow: "Prehľad",
    title: "Prehľad predplatných",
    description:
      "Sledujte aktívne predplatné, kontrolujte celkové výdavky a spravujte importované aj manuálne položky v jednej tabuľke.",
    stats: {
      totalSubscriptions: "Počet predplatných",
      monthlyCost: "Mesačné náklady",
      annualCost: "Ročné náklady",
    },
    list: {
      title: "Vaše predplatné",
      description: "Manuálne aj importované predplatné sú na jednom mieste.",
      addButton: "Pridať predplatné",
      editTitle: "Upraviť predplatné",
      addTitle: "Pridať predplatné",
      searchPlaceholder: "Hľadať podľa názvu alebo kategórie",
      allFrequencies: "Všetky frekvencie",
      noSubscriptions:
        "Zatiaľ nemáte žiadne predplatné. Pridajte ho ručne alebo pripojte Gmail či Outlook v nastaveniach.",
      noMatches: "Žiadne predplatné nezodpovedá aktuálnym filtrom.",
      table: {
        service: "Služba",
        amount: "Suma",
        billing: "Fakturácia",
        frequency: "Frekvencia",
        source: "Zdroj",
        category: "Kategória",
        actions: "Akcie",
      },
      billingDay: "{billingDate}. deň",
      deleteConfirm: "Naozaj chcete odstrániť toto predplatné?",
      addSuccess: "Predplatné bolo úspešne pridané.",
      addFailed: "Predplatné sa nepodarilo pridať",
      updateSuccess: "Predplatné bolo úspešne aktualizované.",
      updateFailed: "Predplatné sa nepodarilo aktualizovať",
      deleteSuccess: "Predplatné bolo úspešne odstránené.",
      deleteFailed: "Predplatné sa nepodarilo odstrániť",
    },
    form: {
      serviceName: "Názov služby",
      amount: "Suma",
      currency: "Mena",
      billingDate: "Dátum účtovania",
      frequency: "Frekvencia",
      category: "Kategória",
      addSubmit: "Pridať predplatné",
      updateSubmit: "Aktualizovať predplatné",
    },
    frequency: {
      monthly: "Mesačne",
      annual: "Ročne",
    },
    source: {
      manual: "Manuálne",
      googleImport: "Import z Gmailu",
      microsoftImport: "Import z Outlooku",
    },
    categories: {
      Entertainment: "Zábava",
      Productivity: "Produktivita",
      Utilities: "Nástroje",
      Shopping: "Nakupovanie",
      Health: "Zdravie",
      Education: "Vzdelávanie",
      Finance: "Financie",
      Other: "Ostatné",
    },
    emailImportCard: {
      title: "Import faktúr z e-mailu",
      description:
        "Pripojte Gmail alebo Outlook v nastaveniach. Importujú sa len faktúry doručené po pripojení.",
      cta: "Spravovať import e-mailov",
    },
  },
  settings: {
    breadcrumb: {
      root: "Nastavenia",
      imports: "Nastavenia / Import e-mailov",
      notifications: "Nastavenia / Upozornenia",
      guide: "Nastavenia / Sprievodca",
    },
    callback: {
      connected: "{provider} bol pripojený",
      failed: "Pripojenie e-mailového poskytovateľa zlyhalo",
      connectionStatus: "Stav pripojenia",
    },
    notifications: {
      title: "Doručovanie pripomienok",
      emailTitle: "E-mailové upozornenia",
      emailDescription:
        "Dostávajte pripomienky na obnovenie sledovaných predplatných.",
      timingTitle: "Čas pripomienky",
      timingDescription:
        "Vyberte, koľko dní pred dátumom fakturácie má pripomienka prísť.",
      save: "Uložiť nastavenia",
      saving: "Ukladá sa...",
      saveSuccess: "Nastavenia upozornení boli úspešne uložené.",
      saveFailed: "Nastavenia sa nepodarilo uložiť",
      options: {
        one: "1 deň vopred",
        two: "2 dni vopred",
        three: "3 dni vopred",
        five: "5 dní vopred",
        seven: "7 dní vopred",
        fourteen: "14 dní vopred",
      },
    },
    language: {
      title: "Jazyk",
      description:
        "Vyberte jazyk používaný v aplikácii a v pripomienkových e-mailoch.",
      saveFailed: "Nepodarilo sa uložiť nastavenie jazyka",
    },
    imports: {
      title: "Pripojené schránky",
      description:
        "Pripojte Gmail na sledovanie nových fakturačných e-mailov. Import sa začne až od času pripojenia a položky sa automaticky zoskupia do opakovaných predplatných.",
      providers: {
        google: {
          description:
            "Sledujte nové faktúry a e-maily o obnovení, ktoré prídu do Gmailu po vytvorení pripojenia.",
        },
        microsoft: {
          description: "Podpora importu z Outlooku je plánovaná, ale zatiaľ nie je dostupná.",
        },
      },
      testEmail: "Odoslať testovací e-mail importu",
      testingEmail: "Odosiela sa...",
      testEmailSuccess:
        "Testovací e-mail podobný predplatnému bol odoslaný. Skontrolujte si schránku.",
      testEmailFailed: "Testovací e-mail sa nepodarilo odoslať",
      importPolicyEyebrow: "Pravidlá importu",
      importPolicyTitle: "Čo sa stane po pripojení",
      lastSyncUnavailable: "Ešte nebolo synchronizované",
      connectionFields: {
        address: "Pripojená adresa",
        lastSync: "Posledná synchronizácia",
      },
      states: {
        comingSoon: "Čoskoro",
        notConnected: "Nepripojené",
        needsAttention: "Vyžaduje pozornosť",
        connected: "Pripojené",
      },
      actions: {
        connect: "Pripojiť {provider}",
        reconnect: "Znovu pripojiť {provider}",
        redirecting: "Presmerovanie...",
        sync: "Synchronizovať teraz",
        syncing: "Synchronizuje sa...",
        disconnect: "Odpojiť",
        disconnecting: "Odpája sa...",
      },
      syncComplete:
        "Synchronizácia dokončená. Importovaných alebo aktualizovaných bolo {imported} predplatných z {processed} nových e-mailov.",
      connectFailed: "Nepodarilo sa pripojiť {provider}",
      syncFailed: "Nepodarilo sa synchronizovať {provider}",
      disconnectConfirm:
        "Odpojiť {provider}? Nové fakturačné e-maily sa prestanú importovať.",
      disconnectSuccess: "{provider} bol odpojený.",
      disconnectFailed: "Poskytovateľa sa nepodarilo odpojiť",
      policy: {
        startTitle: "Začína od času pripojenia",
        startDescription:
          "Submind sleduje iba e-maily, ktoré prídu po pripojení schránky. História schránky zostane nedotknutá.",
        signalsTitle: "Hľadá fakturačné signály",
        signalsDescription:
          "Nové faktúry a e-maily o obnovení sa analyzujú na opakované platby ešte predtým, než sa čokoľvek pridá do prehľadu.",
        confidentTitle: "Importuje len spoľahlivé zhody",
        confidentDescription:
          "Zhody s vysokou istotou automaticky vytvoria alebo aktualizujú predplatné. Neisté e-maily sa preskočia.",
      },
    },
  },
  currency: {
    usd: {
      label: "Americký dolár",
      description: "Americký dolár",
    },
    eur: {
      label: "Euro",
      description: "Euro",
    },
    gbp: {
      label: "Britská libra",
      description: "Britská libra",
    },
  },
  emails: {
    reminder: {
      subject: "Pripomienka: obnovenie {subscriptionName} sa blíži",
      brand: "Pripomienka Submind",
      title: "Blížiace sa obnovenie predplatného",
      intro: "Vaše predplatné sa čoskoro obnoví.",
      service: "Služba",
      amount: "Suma",
      billingDate: "Dátum fakturácie",
      billingDateValue: "{billingDate}. deň v mesiaci",
      daysUntil: "Dní do obnovenia",
    },
    importTest: {
      subject: "Faktúra od {serviceName} - mesačné predplatné {amount}",
      title: "Faktúra od {serviceName}",
      subtitle: "Potvrdenie platby mesačného predplatného",
      intro: "Platba za vaše mesačné predplatné bola úspešná.",
      plan: "Plán",
      amountCharged: "Účtovaná suma",
      billingFrequency: "Fakturačná frekvencia",
      monthly: "mesačne",
      nextRenewal: "Dátum ďalšieho obnovenia",
      footer:
        "Toto je testovací fakturačný e-mail od Submind, aby ste si mohli overiť automatický import predplatného.",
    },
  },
};

export default sk;
